/* Espressoshop: favoriter i webbläsaren (localStorage). Ingen inloggning krävs. */
(() => {
  // Skriptet laddas från både sidhuvudet och favoritsidan; kör bara en gång.
  if (window.esFavoriter) return;
  window.esFavoriter = true;
  const KEY = "es_favoriter";
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} update(); };
  const has = (handle) => read().some((f) => f.handle === handle);

  function update() {
    const n = read().length;
    document.querySelectorAll("[data-es-fav-count]").forEach((el) => { el.textContent = n; el.hidden = n === 0; });
    document.querySelectorAll("[data-es-fav]").forEach((btn) => {
      const on = has(btn.dataset.handle);
      btn.setAttribute("aria-pressed", String(on));
      const label = btn.querySelector("[data-es-fav-label]");
      if (label) label.textContent = on ? btn.dataset.labelOn : btn.dataset.labelOff;
      else { btn.setAttribute("aria-label", on ? btn.dataset.labelOn : btn.dataset.labelOff); btn.title = btn.getAttribute("aria-label"); }
    });
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-es-fav]");
    if (btn) {
      const list = read(); const h = btn.dataset.handle;
      write(has(h) ? list.filter((f) => f.handle !== h) : [...list, { handle: h, title: btn.dataset.title, image: btn.dataset.image, url: btn.dataset.url }]);
      return;
    }
    const rm = e.target.closest("[data-es-fav-remove]");
    if (rm) { write(read().filter((f) => f.handle !== rm.dataset.esFavRemove)); renderList(); }
  });

  const money = (cents) => (cents / 100).toLocaleString(document.documentElement.lang || "sv", { style: "currency", currency: window.Shopify?.currency?.active || "SEK" });
  const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  let renderId = 0;
  async function renderList() {
    const root = document.querySelector("[data-es-fav-list]"); if (!root) return;
    const id = ++renderId;
    const list = read().filter((f, i, all) => all.findIndex((x) => x.handle === f.handle) === i);
    const empty = root.querySelector("[data-es-fav-empty]"), grid = root.querySelector("[data-es-fav-grid]");
    empty.hidden = list.length > 0;
    const prefix = (window.Shopify?.routes?.root || "/").replace(/\/$/, "");
    const produkter = await Promise.all(list.map(async (f) => {
      try { const r = await fetch(`${prefix}/products/${encodeURIComponent(f.handle)}.js`); return r.ok ? [f, await r.json()] : null; } catch { return null; }
    }));
    if (id !== renderId) return; // en nyare rendering har startat
    grid.innerHTML = produkter.filter(Boolean).map(([f, p]) => {
      const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes("?") ? "&" : "?"}width=400` : f.image;
      return `<li class="es-fav-kort">
        <a href="${esc(p.url || f.url)}">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy" width="400" height="400">` : ""}<span class="es-fav-kort__titel">${esc(p.title)}</span></a>
        <span class="es-fav-kort__pris">${p.available ? money(p.price) : esc(root.dataset.soldOut)}</span>
        <button type="button" class="es-fav-kort__ta-bort" data-es-fav-remove="${esc(f.handle)}">${esc(root.dataset.remove)}</button></li>`;
    }).join("");
  }

  const start = () => { update(); renderList(); };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start();
  window.addEventListener("storage", (e) => { if (e.key === KEY) start(); });
})();
